export const panelbrandingConstants = {
    GETALL_REQUEST: 'PANELBRANDING_GETALL_REQUEST',
    GETALL_SUCCESS: 'PANELBRANDING_GETALL_SUCCESS',
    GETALL_FAILURE: 'PANELBRANDING_GETALL_FAILURE',

    DELETE_REQUEST: 'PANELBRANDING_DELETE_REQUEST',
    DELETE_SUCCESS: 'PANELBRANDING_DELETE_SUCCESS',
    DELETE_FAILURE: 'PANELBRANDING_DELETE_FAILURE'
};
